//========== PRODUCT PAGE ==========//
Shopify.optionsMap = {};
Shopify.optionsMapQuickview = {};
function updatePricing() {
  //try pattern one before pattern 2
  var regex = /([0-9]+[.|,][0-9]+[.|,][0-9]+)/g;
  var unitPriceTextMatch = $('.product .price').text().match(regex);

  if (!unitPriceTextMatch) {
    regex = /([0-9]+[.|,][0-9]+)/g;
    unitPriceTextMatch = $('.product .price').text().match(regex);      
  }

  if (unitPriceTextMatch) {
    var unitPriceText = unitPriceTextMatch[0];      
    var unitPrice = unitPriceText.replace(/[.|,]/g,'');
    var quantity = parseInt($('#quantity').val());
    var totalPrice = unitPrice * quantity;

    var totalPriceText = Shopify.formatMoney(totalPrice, window.money_format);

    totalPriceText = totalPriceText.match(regex)[0];

    var regInput = new RegExp(unitPriceText, "g");  
    var totalPriceHtml = $('.product .price').html().replace(regInput ,totalPriceText); 

    $('.product .total-price span').html(totalPriceHtml);      
  }
}
function updatePricingQuickView() {
  
  /*recaculate total price*/
  //try pattern one before pattern 2
  var regex = /([0-9]+[.|,][0-9]+[.|,][0-9]+)/g;
  var unitPriceTextMatch = jQuery('.quick-view-product .price').text().match(regex);

  if (!unitPriceTextMatch) {
    regex = /([0-9]+[.|,][0-9]+)/g;
    unitPriceTextMatch = jQuery('.quick-view-product .price').text().match(regex);      
  }

  if (unitPriceTextMatch) {
    var unitPriceText = unitPriceTextMatch[0];      
    var unitPrice = unitPriceText.replace(/[.|,]/g,'');
    var quantity = parseInt(jQuery('.quick-view-product input[name=quantity]').val());
    var totalPrice = unitPrice * quantity;

    var totalPriceText = Shopify.formatMoney(totalPrice, window.money_format);

    totalPriceText = totalPriceText.match(regex)[0];
    
    //07-03-17
 	var upd_price = Shopify.formatMoney(Currency.convert(unitPrice, Currency.default_curr, Currency.currentCurrency),Currency.moneyFormats[Currency.currentCurrency].money_format);
    jQuery('.quick-view-product #ProductPrice').html(upd_price);
    //ends here
    
    var regInput = new RegExp(unitPriceText, "g");  
    var totalPriceHtml = jQuery('.quick-view-product .price').html().replace(regInput ,totalPriceText); 
    jQuery('.quick-view-product .total-price span').html(totalPriceHtml);      
  }/*end of price calculation*/
}
function updateOptionsInSelector(t) {
  switch (t) {
    case 0:
      var n = "root";
      var r = $(".single-option-selector:eq(0)");
      break;
    case 1:
      var n = $(".single-option-selector:eq(0)").val();
      var r = $(".single-option-selector:eq(1)");
      break;
    case 2:
      var n = $(".single-option-selector:eq(0)").val();
      n += " / " + $(".single-option-selector:eq(1)").val();
      var r = $(".single-option-selector:eq(2)")
      }
  var i = r.val();
  r.empty();
  var s = Shopify.optionsMap[n];
  if(typeof s != "undefined"){
    for (var o = 0; o < s.length; o++) {
      var u = s[o];
      var a = $("<option></option>").val(u).html(u);
      r.append(a)
    }
  }
  $('.swatch[data-option-index="' + t + '"] .swatch-element').each(function() {
    if ($.inArray($(this).attr("data-value"), s) !== -1) {
      $(this).removeClass("soldout").show().find(":radio").removeAttr("disabled", "disabled").removeAttr("checked")
    } else {
      $(this).addClass("soldout").hide().find(":radio").removeAttr("checked").attr("disabled", "disabled")
    }
  });
  if ($.inArray(i, s) !== -1) {
    r.val(i)
  }
  r.trigger("change")
};
function linkOptionSelectors(t) {
  for (var n = 0; n < t.variants.length; n++) {
    var r = t.variants[n];
    if (r.available) {
      Shopify.optionsMap["root"] = Shopify.optionsMap["root"] || [];
      Shopify.optionsMap["root"].push(r.option1);
      Shopify.optionsMap["root"] = Shopify.uniq(Shopify.optionsMap["root"]);
      if (t.options.length > 1) {
        var i = r.option1;
        Shopify.optionsMap[i] = Shopify.optionsMap[i] || [];
        Shopify.optionsMap[i].push(r.option2);
        Shopify.optionsMap[i] = Shopify.uniq(Shopify.optionsMap[i])
      }
      if (t.options.length === 3) {
        var i = r.option1 + " / " + r.option2;
        Shopify.optionsMap[i] = Shopify.optionsMap[i] || [];
        Shopify.optionsMap[i].push(r.option3);
        Shopify.optionsMap[i] = Shopify.uniq(Shopify.optionsMap[i])
      }
    }
  }
  updateOptionsInSelector(0);
  if (t.options.length > 1)
    updateOptionsInSelector(1);
  if (t.options.length === 3)
    updateOptionsInSelector(2);
  $(".single-option-selector:eq(0)").change(function() {
    updateOptionsInSelector(1);
    if (t.options.length === 3)
      updateOptionsInSelector(2);
    return true
  });
  $(".single-option-selector:eq(1)").change(function() {
    if (t.options.length === 3)
      updateOptionsInSelector(2);
    return true
  })
}

function addCheckedSwatch(){
  $('.swatch .color label').on('click', function () {      
    $('.swatch .color').each(function(){
      $(this).find('label').removeClass('checkedBox');
    });
    $(this).addClass('checkedBox');      
  });
}

$(document).ready(function(){
    
  		iniQuickView();
  

});

function scrollCompensate() 
{
    var inner = document.createElement('p');
    inner.style.width = "100%";
    inner.style.height = "200px";

    var outer = document.createElement('div');
    outer.style.position = "absolute";
    outer.style.top = "0px";
    outer.style.left = "0px";
    outer.style.visibility = "hidden";
    outer.style.width = "200px";
    outer.style.height = "150px";
    outer.style.overflow = "hidden";
    outer.appendChild(inner);

    document.body.appendChild(outer);
    var w1 = inner.offsetWidth;
    outer.style.overflow = 'scroll';
    var w2 = inner.offsetWidth;
    if (w1 == w2) w2 = outer.clientWidth;

    document.body.removeChild(outer);

    return (w1 - w2);
}

	var product = {};
	var currentLinkQuickView = '';
	var option1 = '';
	var option2 = '';

	function setButtonNavQuickview() {
      $("#quickview-nav-button a").hide();
      $("#quickview-nav-button a").attr("data-index", "");
      var listProducts = $(currentLinkQuickView).closest(".slide").find("a.quick-view");
      if(listProducts.length > 0) {
        var currentPosition = 0;
        for(var i = 0; i < listProducts.length; i++) {
          if($(listProducts[i]).data("handle") == $(currentLinkQuickView).data("handle")) {
            currentPosition = i;
            break;
          }
        }
        if(currentPosition < listProducts.length - 1) {
          $("#quickview-nav-button .btn-next-product").show();
          $("#quickview-nav-button .btn-next-product").attr("data-index", currentPosition + 1);
        }
        if(currentPosition > 0) {
          $("#quickview-nav-button .btn-previous-product").show();
          $("#quickview-nav-button .btn-previous-product").attr("data-index", currentPosition - 1);
        }
      }
      $("#quickview-nav-button a").click(function() {
        $("#quickview-nav-button a").hide();
        var indexLink = parseInt($(this).data("index"));
        if(!isNaN(indexLink) && indexLink >= 0) {
          	var listProducts = $(currentLinkQuickView).closest(".slide").find("a.quick-view");
          	if(listProducts.length > 0 && indexLink < listProducts.length) {
              	//$(".quickview-close").trigger("click");
          		$(listProducts[indexLink]).trigger("click");
            }
        }
      });
    }

	function iniQuickView(){
      
      	$(document).on("click", "#thumblist_qview li", function() {
          changeImageQuickView($(this).find("img:first-child"), "#product-featured-image-quickview");
        });
      
		$(document).on('click', '.quick-view', function(e){
          
          
              
			var producthandle = $(this).data("handle");
			Shopify.getProduct(producthandle,function(product){
				var qvhtml = $("#quickview-modal").html();
				$(".quick-view-product").html(qvhtml);
				var quickview= $(".quick-view-product");
              
              //$(".prod_url").attr('href',producthandle);
				var productdes = product.description.replace(/(<([^>]+)>)/ig,"");
				var featured_image = product.featured_image;
				productdes = productdes.split(" ").splice(0,30).join(" ")+"...";
				quickview.find(".view_full_size a").attr("title",product.title);
				quickview.find(".view_full_size a").attr("href",'/products/'+producthandle);
				quickview.find(".view_full_size img").attr("src",featured_image);
				quickview.find(".view_full_size img").attr("alt",product.title);

				quickview.find(".price").html(Shopify.formatMoney(product.price, window.money_format));
                quickview.find(".product-item").attr("id", "product-" + product.id);
                quickview.find(".variants").attr("id", "product-actions-" + product.id);
				quickview.find(".variants select").attr("id", "product-select-" + product.id);

				quickview.find(".product-info .qwp-name").text(product.title);
				quickview.find(".review .shopify-product-reviews-badge").attr("data-id",product.id);
              	quickview.find(".product-info .brand").append("<span>Vendor: </span>"+product.vendor);
                if(product.available){
                  quickview.find(".product-info .availability").append("<p>Available: <span>In stock</span></p>");
                }else{
                  // Variant is sold out, disable the submit button - addtocart and show sold out text
          		  quickview.find(".product-form__item--submit .ajaxaddtocart").val('Sold Out').addClass('disabled').attr('disabled', 'disabled');
                  quickview.find(".product-form__item--submit .ajaxaddtocart span").html('Sold Out');
                  //ended here                                                     
                  quickview.find(".product-info .availability").append("<p>Available: <span>Sold out</span></p>");
                }                
                quickview.find(".product-info .product-sku").append("<p>SKU: <span>"+product.variants[0].sku+"</span></p>");
                  
				quickview.find(".product-description").text(productdes);

                if (product.compare_at_price > product.price) {
                    quickview.find(".compare-price").html(Shopify.formatMoney(product.compare_at_price_max, window.money_format)).show();
                    quickview.find(".price").addClass("on-sale")
                }
                else {
                    quickview.find(".compare-price").html("");
                    quickview.find(".price").removeClass("on-sale")
                } 
                if (!product.available) {
                  	//07-03-17
                  	 var upd_price1 = Shopify.formatMoney(Currency.convert(product.price, Currency.default_curr, Currency.currentCurrency),Currency.moneyFormats[Currency.currentCurrency].money_format);
    				 quickview.find("#ProductPrice").html(upd_price1);
                  	 //ends here
                  
                    quickview.find("select, input, .dec, .inc, .variants label").remove();
                    quickview.find(".add_to_cart_detail").text("Unavailable").addClass("disabled").attr("disabled", "disabled");
                  	$(".quantity_wanted_p").css("display", "none");
                 	
                }
                else {
                  	$(".quantity_wanted_p").css("display", "block");
                  
                    QuickViewVariantsSwatch(product, quickview);
                  
                  	
           			$.each(product.variants, function(a, b) {
              		var featured_json_obj = JSON.parse(JSON.stringify(b.featured_image));
              		$.each(featured_json_obj, function(i, item) {
                		if(i == 'src'){
               	 		$('#imgswatch').append("<input type='hidden' id='"+b.id+"' name='' data-zoom-image='"+item+"' value='"+item+"' >");
                		}
					});
             	 	})
         			
                }
                  
                  
                $("#quick-view-product").fadeIn(500);
                $(".view_scroll_spacer").removeClass("hidden");
                loadQuickViewSlider(product, quickview);
                  
                  loadQuickViewAddtocart();
                $(".quick-view").fadeIn(500);
                if ($(".quick-view .total-price").length > 0) {
                  $(".quick-view input[name=quantity]").on("change", updatePricingQuickView)
                }
              	updatePricingQuickView();
              	// Setup listeners to add/subtract from the input
                $(".js-qty__adjust").on("click", function() {
                  var el = $(this),
                      id = el.data("id"),
                      qtySelector = el.siblings(".js-qty__num"),
                      qty = parseInt(qtySelector.val().replace(/\D/g, ''));

                  var qty = validateQty(qty);

                  // Add or subtract from the current quantity
                  if (el.hasClass("js-qty__adjust--plus")) {
                    qty = qty + 1;
                  } else {
                    qty = qty - 1;
                    if (qty <= 1) qty = 1;
                  }

                  // Update the input's number
                  qtySelector.val(qty);
                  updatePricingQuickView();
                });
                $(".js-qty__num").on("change", function() {
                  updatePricingQuickView();
                });
			});
			return false;
		});
	
    }
   
    function loadQuickViewAddtocart() {
           $(document).ready(function() {
	 sl.init(), ab.init()
     
  });
        }
      
    
	function loadQuickViewSlider(n, r) {
   
      var s = Shopify.resizeImage(n.featured_image, "grande");
      r.find(".quickview-featured-image").append('<a href="' + n.url + '"><img src="' + s + '" title="' + n.title + '"/><div style="height: 100%; width: 100%; top:0; left:0 z-index: 2000; position: absolute; display: none; background: url(' + window.loading_url + ') 50% 50% no-repeat;"></div></a>');
      if (n.images.length > 0) {
        var o = r.find(".more-view-wrapper ul");
        for (i in n.images) {
          var u = Shopify.resizeImage(n.images[i], "grande");
          var a = Shopify.resizeImage(n.images[i], "compact");
          var f = '<li class="thumb_item item"><a href="javascript:void(0)" data-image="' + u + '"><img class="img-responsive" src="' + a + '"  /></a></li>';
          o.append(f)
        }
       
        if(n.images.length <5){
          $(".view_scroll_spacer").addClass("hidden");
        }else if(n.images.length >= 5){
       //  loadthumbSlider(o);
        }
      } else {        
        r.find(".quickview-more-views").remove();
        r.find(".quickview-more-view-wrapper-jcarousel").remove()
      }
     
    }
      
	function updateQuantity(){
		$('.js-qty__adjust').on('click', function() {
			var el = $(this),
				id = el.data('id'),
				qtySelector = el.siblings('.js-qty__num'),
	            qty = parseInt(qtySelector.val().replace(/\D/g, ''));

	        var qty = validateQty(qty);

	        // Add or subtract from the current quantity
	        if (el.hasClass('js-qty__adjust--plus')) {
	          qty = qty + 1;
	        } else {
	          qty = qty - 1;
	          if (qty <= 1) qty = 1;
	        }

	        // Update the input's number
	        qtySelector.val(qty);
          	updatePricing();
      	});
	}
	validateQty = function (qty) {
	    // Make sure we have a valid integer
	    if((parseFloat(qty) == parseInt(qty)) && !isNaN(qty)) {
	      // We have a number!
	    } else {
	      // Not a number. Default to 1.
	      qty = 1;
	    }
	    return qty;
  	};
	var convertToSlug = function (e) {
        return e.toLowerCase().replace(/[^a-z0-9 -]/g, "").replace(/\s+/g, "-").replace(/-+/g, "-")
    }
    
    function QuickViewVariants(t, quickview) {      	
        if (t.variants.length > 1) {
            for (var r = 0; r < t.variants.length; r++) {
                var i = t.variants[r];
                var s = '<option value="' + i.id + '">' + i.title + "</option>";
                quickview.find("form.variants > select").append(s)
            }
        
            new Shopify.OptionSelectors("product-select-" + t.id, { product: t, onVariantSelected: selectCallbackQuickView });
          
          var o = window.file_url.substring(0, window.file_url.lastIndexOf("?"));
            var u = window.asset_url.substring(0, window.asset_url.lastIndexOf("?"));
            var a = "";
          
          var s = 0;
          quickview.find(".selector-wrapper label").each(function() {
            $(this).html(t.options[s].name);
            s++;
			});
          quickview.find(".selector-wrapper").show();
            if (t.available) {
                Shopify.optionsMap = {}; 
              	linkOptionSelectors(t);
            }
          	addCheckedSwatch();
        }
        else {
            quickview.find("form.variants > select").remove();
            var v = '<input type="hidden" name="id" value="' + t.variants[0].id + '">';
            quickview.find("form.variants").append(v)
        }
    }
	function QuickViewVariantsSwatch(t, quickview) {   
      
        if (t.variants.length > 1) {
            for (var r = 0; r < t.variants.length; r++) {
                var i = t.variants[r];
                var s = '<option value="' + i.id + '">' + i.title + "</option>";
                quickview.find("form.variants > select").append(s)
            }
            new Shopify.OptionSelectors("product-select-" + t.id, { product: t, onVariantSelected: selectCallbackQuickView });
            var o = window.file_url.substring(0, window.file_url.lastIndexOf("?"));
            var u = window.asset_url.substring(0, window.asset_url.lastIndexOf("?"));
            var a = "";
            for (var r = 0; r < t.options.length; r++) {
                a += '<div class="swatch clearfix" data-option-index="' + r + '">';
                a += '<div class="header">' + t.options[r].name + "</div>";
                var f = false;
                if (/Color|Colour/i.test(t.options[r].name)) { f = true } var l = new Array;
                for (var c = 0; c < t.variants.length; c++) {
                    var i = t.variants[c]; var h = i.options[r];
                    var p = this.convertToSlug(h);
                    var d = "swatch-" + r + "-" + p;
                    if (l.indexOf(h) < 0) {
                        a += '<div data-value="' + h + '" class="swatch-element ' + (f ? "color " : "") + p + (i.available ? " available " : " soldout ") + '">';
                        if (f) {
                            a += '<div class="tooltip">' + h + "</div>"
                        }
                        a += '<input id="' + d + '" type="radio" name="option-' + r + '" value="' + h + '" ' + (c == 0 ? " checked " : "") + (i.available ? "" : " disabled") + "  data-id='"+i.id+"'/>";
                        if (f) {
                            a += '<label class="'+ p +'" for="' + d + '" style="background-color: ' + p + "; background-image: url(" + o + p + '.png)"><img class="crossed-out" src="' + u + 'soldout.png" /><i></i></label>'
                        }
                        else {
                            a += '<label class="'+ p +'" for="' + d + '">' + h + '<img class="crossed-out" src="' + u + 'soldout.png" /></label>'
                        }
                        a += "</div>";
                        if (i.available) {
                            $('.quick-view .swatch[data-option-index="' + r + '"] .' + p).removeClass("soldout").addClass("available").find(":radio").removeAttr("disabled")
                        } l.push(h)
                    }
                } a += "</div>"
            }
            quickview.find("form.variants > select").after(a);
            quickview.find(".swatch :radio").change(function () {
             
              	
              	var t = $(this).closest(".swatch").attr("data-option-index");
                var quickview = $(this).val();
                $(this).closest("form").find(".single-option-selector").eq(t).val(quickview).trigger("change");
              	
              	//07-03-17
              	var variant_id = $(this).attr("data-id");
                var variant_img_src = $("#imgswatch").find("#"+variant_id).val();
               	$(".quick-view-product #product-featured-image-quickview").attr("src",variant_img_src);
              	//ends here
              
            });
             quickview.find(".selector-wrapper").hide();
            if (t.available) {
                Shopify.optionsMap = {}; 
              	linkOptionSelectors(t);
            }
          	addCheckedSwatch();
        }
        else {
            quickview.find("form.variants > select").remove();
            var v = '<input type="hidden" name="id" value="' + t.variants[0].id + '">';
            quickview.find("form.variants").append(v)
        }
    }
	$(document).on('click', '.quick-view', function(e){
		e.preventDefault();
	});
	$(document).on('click', '.quickview-close, #quick-view-product .quickview-overlay', function(e){
      
        var skipContents = $('.skip-content');
        var skipLinks = $('.skipLink');
        skipLinks.on('click', function (e) {
        e.preventDefault();
            var target = $(this).attr('data-target') ? $(this).attr('data-target') : $(this).attr('href'),
            	elem = $(target),
            	isSkipContentOpen = elem.hasClass('skip-active') ? 1 : 0;

            skipLinks.removeClass('skip-active');
            skipContents.removeClass('skip-active');

            if (isSkipContentOpen){
               $(this).removeClass('skip-active');
            } else {
                $(this).addClass('skip-active');
                elem.addClass('skip-active');
            }
     	});
      	/* ended here ***/
		$("#quick-view-product").fadeOut(500);
	});

 function productZoom(){
	$('.jqzoom').jqzoom({
		zoomType: 'innerzoom', //innerzoom/standard/reverse/drag
		zoomWidth: 458, //zooming div default width(default width value is 200)
		zoomHeight: 458, //zooming div default width(default height value is 200)
		xOffset: 21, //zooming div default offset(default offset value is 10)
		yOffset: 0,
		title: false
	});
}
function productImage(){
	$('#thumblist').height(parseInt($('#thumblist >li').outerHeight(true) * $('#thumblist >li').length) + 'px').css('marginBottom');
 
	$('.thumbs_list_frame_2').height(parseInt($('.thumbs_list_frame_2 >li').outerHeight(true) * $('.thumbs_list_frame_2 >li').length) + 'px').css('marginBottom');
 	if (!!$.prototype.fancybox){
		$('li:visible .fancybox, .fancybox.shown').fancybox({
			'hideOnContentClick': true,
			'openEffect'	: 'elastic',
			'closeEffect'	: 'elastic'
		});
	}
}
          
  var sl = {
      init: function() {
        this.skiplinks();
      },

      skiplinks: function() {
        var skipContents = $('.skip-content');
        var skipLinks = $('.skipLink');

        skipLinks.on('click', function (e) {
            e.preventDefault();
            var target = $(this).attr('data-target') ? $(this).attr('data-target') : $(this).attr('href'),
            	elem = $(target),
            	isSkipContentOpen = elem.hasClass('skip-active') ? 1 : 0;

            skipLinks.removeClass('skip-active');
            skipContents.removeClass('skip-active');

            if (isSkipContentOpen){
                $(this).removeClass('skip-active');
            } else {
                $(this).addClass('skip-active');
                elem.addClass('skip-active');
            }
        });
     }
  };
  
  var ab = {
    drawerTimeout: null,
   
    init: function() {
      this.hideDrawer(),this.quickviewAddToCart()   
    },  
    quickviewAddToCart: function() {
      var cartBtn = $(".ajaxaddtocart"),
      	  pName = $(".quick-view-product .qwp-name").text(),
          pImg = $(".view_full_size #product-featured-image-quickview").attr("src");

      $(cartBtn).click(function(i) {
      
        if (i.preventDefault(), "disabled" != $(this).attr("disabled"))
          if (theme.ajax_cart) {
            var att = $(".form-ajaxtocart select[name=id]").val();
            	att || (att = $(".form-ajaxtocart input[name=id]").val());
            var qty = $(".form-ajaxtocart input[name=quantity]").val();
            	qty || (qty = 1);

            ab.addinToCart(att, qty)
          } else {
            $(".form-ajaxtocart").submit();
          }
        return;
      })
    
    },
    showLoadingBox: function() {
		$("body").addClass("loading");
	},
	hideLoadingBox: function() {
		$("body").removeClass("loading");
    },
  	showDrawer: function(i) {
      $("body").addClass("showOverly"),$(i).fadeIn(500), ab.drawerTimeout = setTimeout(function() {
        $("body").removeClass("showOverly"),$(i).fadeOut(500)
      }, 5e3)
    },
    hideDrawer: function() {
      $(".continue-shopping, .modalOverly, .closeDrawer").click(function() {
        clearTimeout(ab.drawerTimeout), $(this).closest(".modal").fadeOut(500);
        $("body").removeClass("showOverly");
      }),
      $(".modalOverly").click(function() {
        clearTimeout(ab.drawerTimeout), $("#cartDrawer,#cartError").fadeOut(500);
       $("body").removeClass("showOverly");
      })
    },
    addinToCart: function(att, qty ) {
      CartJS.addItem(att, qty, {     
      }, {
          "success": function(data, textStatus, jqXHR){
			 $("#cartDrawer").find(".modal-prod-img").attr("src", data.image);
             $("#cartDrawer").find(".modal-prod-img").load(function() {
               ab.hideLoadingBox(),
               $("#cartDrawer").find(".modal-prod-name").text(data.product_title),
               $("#cartDrawer").find(".cartText").show(),
               ab.showDrawer("#cartDrawer"); 
               
            });
          },
          "error": function(jqXHR, textStatus, errorThrown){
            var errormsg = JSON.parse(jqXHR.responseText).description;
            ab.hideLoadingBox(),
            $(".error-message").text(errormsg), ab.showDrawer("#cartError");
          }
      });
    },
    closeDrawer: function() {
    	$(".closeDrawer").click(function() {
          ab.hideLoading(), ab.hideDrawer();
        })
  	}
  }
  
/*****************/
    Shopify.doNotTriggerClickOnThumb = false;
  function changeImageQuickView(img, selector) {
    var src = $(img).attr("src");
    src = src.replace("_compact", "");
    $(selector).attr("src", src);
  }
  var selectCallbackQuickView = function(variant, selector) {
      var productItem = jQuery('.quick-view-product .product-item');
        // addToCart = productItem.find('.add-to-cart-btn'),
    	  addToCart = productItem.find('.ajaxaddtocart'),
          productPrice = productItem.find('.price'),
          comparePrice = productItem.find('.compare-price'),
          totalPrice = productItem.find('.total-price span');

      if (variant) {
        if (variant.available) {
         
          // We have a valid product variant, so enable the submit button
          addToCart.removeClass('disabled').removeAttr('disabled').text('Add to Cart');    
        } else {
          // Variant is sold out, disable the submit button
          addToCart.val('Sold Out').addClass('disabled').attr('disabled', 'disabled');
        }    	
        // Regardless of stock, update the product price
        productPrice.html(Shopify.formatMoney(variant.price, ""));
    
        // Also update and show the product's compare price if necessary
        if ( variant.compare_at_price > variant.price ) {
          comparePrice
            .html(Shopify.formatMoney(variant.compare_at_price, ""))
            .show();        	
          productPrice.addClass('on-sale');
        } else {
          comparePrice.hide();
          productPrice.removeClass('on-sale');
        }
                            
        
        // BEGIN SWATCHES
          var form = jQuery('#' + selector.domIdPrefix).closest('form');
          for (var i=0,length=variant.options.length; i<length; i++) {
            var radioButton = form.find('.swatch[data-option-index="' + i + '"] :radio[value="' + variant.options[i] +'"]');
            if (radioButton.size()) {
              radioButton.get(0).checked = true;
            }
          }
         // END SWATCHES
        
         
          //update variant inventory
      
          var inventoryInfo = productItem.find('.product-inventory span');
          if (variant.available) {
            if (variant.inventory_management!=null) {
              inventoryInfo.text(variant.inventory_quantity + " in stock");
            } else {
              inventoryInfo.text("Many in stock");
            }
          } else {
            inventoryInfo.text("Out of stock");
          }
      
    	//updatePricingQuickView();
    
       
    	/*begin variant image*/
        if (variant && variant.featured_image) {
          var originalImage = jQuery("#product-featured-image");
          var newImage = variant.featured_image;
          var element = originalImage[0];
          Shopify.Image.switchImage(newImage, element, function (newImageSizedSrc, newImage, element) {
            jQuery('#thumbs_list img').each(function() {
              var grandSize = jQuery(this).attr('src');
              var native = newImageSizedSrc;
              newImageSizedSrc = newImageSizedSrc.replace("https:", "");
              var last = newImageSizedSrc .lastIndexOf("?");
              if(last >= 0) {
              	newImageSizedSrc = newImageSizedSrc.substr(0, newImageSizedSrc.length - (newImageSizedSrc.length - last));
              }
              
              grandSize = grandSize.replace("_compact", "");
              grandSize = grandSize.replace("_grande", "");
              if (grandSize == newImageSizedSrc) {
                changeImageQuickView(newImage);
                return false;
              }
            });
          });        
        }
    	/*end of variant image*/
    
      } else {
        // The variant doesn't exist. Just a safegaurd for errors, but disable the submit button anyway
        addToCart.text('Unavailable').addClass('disabled').attr('disabled', 'disabled');
      }
  };
  /*****************/